module.exports = __webpack_public_path__ + "static/media/neuronet.884ef45b.png";